import {
  Component,
  OnInit,
  ViewChild,
  isDevMode,
  Optional,
  Inject,
  OnDestroy,
  TemplateRef,
  ElementRef,
} from "@angular/core";
import {
  Gateway,
  OnlinePayment,
  PaymentGateways,
  UserPaymentEmail,
  HiGiftStatus,
} from "../../models/payments.model";
import {
  FormGroup,
  FormControl,
  Validators,
  ValidatorFn,
  ValidationErrors,
} from "@angular/forms";
import { MatStepper } from "@angular/material/stepper";
import { SnackBarService } from "src/app/shared/services/snackbar/snackbar";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "src/environments/environment";
import { LocalStorageService } from "src/app/core/services/local-storage/local-storage.service";
import { PaymentService } from "../../services/payment.service";
import { Currency } from "src/app/shared/models/currency.model";
import { PaymentSharedService } from "src/app/shared/services/payments/payments-shared.service";
import { MatDialog } from "@angular/material/dialog";
import { DynamicScriptService } from "src/app/shared/services/dynamic-resource/dynamic-script.service";
import { ResolverService } from "src/app/core";
import { Initials } from "src/app/core/models/initials.model";
import { DOCUMENT } from "@angular/common";
import { Subscription } from "rxjs";
import { NoSpaceValidator } from "../../../../shared/services/validations/no-space-validator";
import { formatNumber } from "@angular/common";
import { LoaderService } from "src/app/core/services/loader/loader.service";
import { GoogleAnalyticsService } from "src/app/shared/services/google-analytics.service";
import { OnlinePaymentInvoicePrintComponent } from "../online-payment-invoice-print/online-payment-invoice-print.component";
declare var bitpay;

@Component({
  selector: "app-create-online-payment",
  templateUrl: "./create-online-payment.component.html",
  styleUrls: ["./create-online-payment.component.scss"],
})
export class CreateOnlinePaymentComponent implements OnInit, OnDestroy {
  @ViewChild("bankTransferInvoice", {static: false}) bankTransferInvoice!: OnlinePaymentInvoicePrintComponent;
  @ViewChild("createPaymentDialog") createPaymentDialog!: TemplateRef<any>;
  @ViewChild("chequeConfirmDialog") chequeConfirmDialog!: TemplateRef<any>;
  @ViewChild("customerCardListDialog")
  customerCardListDialog!: TemplateRef<any>;

  availableGateways: Gateway[];
  availableCurrencies: Currency[];

  paymentForm: FormGroup;
  hiGiftForm: FormGroup;
  paymentEmailForm: FormGroup;
  chequeForm: FormGroup;
  bankTransferForm: FormGroup;

  hiGiftStatus = HiGiftStatus;
  onlinePaymentData: OnlinePayment;
  public payPalConfig?: any;
  ngeniusConfig;
  gatewayReady: boolean = false;
  visibleGateway: string = "";

  isReseller;
  hyphenValue;
  pinSubscribtion$: Subscription;
  selectedGateway: any;
  userInitInfo: Initials;
  // showRightSide: boolean = false;
  showAmount: boolean = false;
  PaymentGateways = PaymentGateways;
  paymentEmailList: UserPaymentEmail[];

  selectedImage: any;
  customerCardList: any;
  isOnlinePaymentRoute: boolean = true;
  envrionmentConfig = environment;
  selectedCategoryId: any;

  @ViewChild('stepper') PaymentStepper: MatStepper
  @ViewChild('createPaymentEmail') createPaymentEmail;
  @ViewChild('checkHiGift') checkHiGift;

  bankTransferCurrencies = [
    {
      code: "EUR",
      symbol: "€"
    },
    {
      code: "USD",
      symbol: "$"
    },
    {
      code: "CAD",
      symbol: "C$"
    },
    {
      code: "GBP",
      symbol: "£"
    },
    {
      code: "AED",
      symbol: "د.إ"
    }
  ]

  constructor(
    private paymentService: PaymentService,
    private sharedService: PaymentSharedService,
    private snackbarService: SnackBarService,
    private localStorage: LocalStorageService,
    private router: Router,
    private dialog: MatDialog,
    private dynamicScriptService: DynamicScriptService,
    private route: ActivatedRoute,
    private resolverService: ResolverService,
    private loaderService: LoaderService,
    @Inject(DOCUMENT) private document: Document,
    private gaService: GoogleAnalyticsService,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if(params['id']) {
        this.selectedCategoryId = params['id'];
        this.getAvailableGateways();
      }
    })
    this.isOnlinePaymentRoute = this.router.url.includes("online-payments/add");
    this.userInitInfo = this.resolverService.userInitInfo;
    this.isReseller =
      this.resolverService.userInitInfo.profile.role.role_id ==
      environment.role_types.reseller;
    // this.getAvailableGateways(); 
    this.initForms();
    this.onNgeniusValidate();
    this.pinValueChanges();
  }

  loadLazyBitpayScript() {
    // console.log('Bitpay Loading');
    this.dynamicScriptService
      .loadBitpayScript()
      .then(() => {})
      .catch(() => {
        this.snackbarService.showSnack("BitPay is not available.");
      });
  }

  getAvailableGateways() {
    // this.paymentService.getOnlinePaymentGateways().subscribe(
    //   (gateways) => {
    //     // this.availableGateways = gateways;
    //     if (this.isOnlinePaymentRoute) {
    //       this.availableGateways = gateways.filter(
    //         (gateway) =>
    //           gateway.id != 45 && gateway.id != 39 && gateway.id != 14
    //       );
    //     } else {
    //       this.availableGateways = this.userInitInfo.profile.reseller
    //         ? this.filterGatewaysByAccess(gateways)
    //         : gateways;
    //     }

    //     if (this.availableGateways.find((item) => item.online_gateway === 2)) {
    //       this.loadLazyBitpayScript();
    //     }
    //   },
    //   (error) => {
    //     this.snackbarService.showSnack(error.detail);
    //   }
    // );
      this.paymentService.getPaymentCategoryList().subscribe(data => {
      const selectedGatewayList = data.find(el => el.category == this.selectedCategoryId).gateways;
      if (this.isOnlinePaymentRoute) {
          this.availableGateways = selectedGatewayList.filter(
            (gateway) =>
              gateway.id != 45 && gateway.id != 39 && gateway.id != 14
          );
        } else {
          this.availableGateways = this.userInitInfo.profile.reseller
            ? this.filterGatewaysByAccess(selectedGatewayList)
            : selectedGatewayList;
        }

        if (this.availableGateways.find((item) => item.online_gateway === 2)) {
          this.loadLazyBitpayScript();
        }

        if(selectedGatewayList.length == 1) {
          this.setGateway(selectedGatewayList[0]);
        }
    },
      (error) => {
        this.snackbarService.showSnack(error.detail);
      });
  }

  filterGatewaysByAccess(gateways) {
    return gateways.filter(
      (item) => item.online_gateway !== PaymentGateways.PAYPAL || item.id == 32
    );
  }

  getAvailableCurrencies() {
    this.sharedService.getCurrencies().subscribe(
      (currencies) => {
        this.availableCurrencies = currencies;
      },
      (error) => {
        this.snackbarService.showSnack(error.detail);
      }
    );
  }

  getCustomerCardList(paymentMethod: any, check_only = true) {
    let filters = {
      verified: true,
    };
    let paymentMethodId = paymentMethod.id;
    this.paymentService
      .getCustomerCards(paymentMethodId, filters)
      .subscribe((cardList) => {
        if (cardList?.length) {
          if (check_only) {
            this.setGateway(paymentMethod, true);
          } else {
            this.closeDialogs();
            this.customerCardList = cardList;
            this.dialog.open(this.customerCardListDialog, {
              width: "500px",
              height: "600px",
              data: {
                ...paymentMethod,
              },
            });
          }
        } else {
          this.getCustomerPanelLink({ gateway: paymentMethodId });
        }
      });
  }

  getCustomerPanelLink(queryParams?: any) {
    let data = {
      gateway: queryParams?.gateway,
      redirect_url: `${environment.gatewayReturnUrl}?id=${this.selectedCategoryId}`
    }
    this.paymentService.getCustomerPanelLink(data).subscribe((res) => {
      if (res.link) {
        window.location.href = res.link;
      }
    });
  }

  initForms() {
    this.paymentForm = new FormGroup(
      {
        amount: new FormControl("", [Validators.required]),
        gateway: new FormControl("", [Validators.required]),
        currency: new FormControl("", [Validators.required]),
        image: new FormControl(),
      },
      [this.amountValidator()]
    );

    this.paymentEmailForm = new FormGroup({
      user_id: new FormControl(
        this.userInitInfo.profile.id,
        Validators.required
      ),
      email: new FormControl("", Validators.required),
    });

    this.hiGiftForm = new FormGroup({
      pin: new FormControl("", [
        Validators.required,
        Validators.minLength(16),
        NoSpaceValidator.cannotContainSpace,
      ]),
    });

    this.bankTransferForm = new FormGroup({
      amount: new FormControl('', Validators.required),
      currency: new FormControl('', Validators.required),
      office: new FormControl('', Validators.required)
    })
  }

  amountValidator(): ValidatorFn {
    return (group: FormGroup): ValidationErrors => {
      const control = group.controls["amount"];
      let val = control.value;
      if (val) {
        // val = val.replaceAll(',', '');
        if (this.selectedGateway.min_price || this.selectedGateway.max_price) {
          if (
            val < this.selectedGateway.min_price ||
            val > this.selectedGateway.max_price
          ) {
            control.setErrors({ invalid: true });
          } else {
            control.setErrors(undefined);
          }
        } else {
          control.setErrors(undefined);
        }
      } else {
        // if (control.disable) {
        //   control.setErrors(undefined)
        // } else {
        control.setErrors({ required: true });
        // }
      }
      return;
    };
  }

  checkGatewayType(gateway) {
    console.log("check gateway type", gateway);
    if (gateway?.payment_method_type != 2) {
      this.getCustomerCardList(gateway, false);
    } else {
      this.initConfig();
    }
  }

  initConfig(cardMethodId?: any): void {
    if (cardMethodId && !this.paymentForm.get("amount")) {
    }
    if (
      this.paymentForm.get("amount").value ||
      this.selectedGateway.online_gateway == PaymentGateways.HIGIFT
    ) {
      const data = { ...this.paymentForm.value };
      this.visibleGateway = data.gateway.online_gateway;
      this.paymentForm.get("image").setValidators(undefined);
      switch (data.gateway.online_gateway) {
        case PaymentGateways.BITPAY:
          this.gatewayReady = true;
          this.initBitpayConfig();
          break;
        case PaymentGateways.PAYPAL:
          // this.showRightSide = true;
          this.getUserPaymentEmails();
          break;
        case PaymentGateways.HIGIFT:
          // this.showRightSide = true;
          this.gatewayReady = true;
          break;
        case PaymentGateways.NGENIUS:
          this.gatewayReady = true;
          this.initNGeniusConfig();
          break;
        case PaymentGateways.JPMORGAN_HPS:
          this.gatewayReady = true;
          this.initNGeniusConfig();
          break;
        case PaymentGateways.PAYTAB:
          this.gatewayReady = true;
          this.initNGeniusConfig();
          break;
        case PaymentGateways.EZPIN_PAYMENT:
          this.gatewayReady = true;
          this.initNGeniusConfig(cardMethodId);
          break;
        case PaymentGateways.CHEQUE:
          this.gatewayReady = true;
          // this.showRightSide = true;
          this.openDialog(this.chequeConfirmDialog);
          break;
        default:
      }
    } else {
      this.snackbarService.showSnack("Choose amount first!");
    }
  }

  initBitpayConfig(): void {
    const payData = { ...this.paymentForm.value };
    payData.gateway = payData.gateway.id;
    // payData.amount = payData.amount.replaceAll(',', '');
    // this.gatewayReady = false;
    // if(payData.currency) delete payData.currency;
    this.paymentService.createOnlinePayment(payData).subscribe(
      (success) => {
        try {
          let eventData = {
            currency:
              this.paymentForm.controls.gateway?.value.currency?.symbol.toString(),
            value: Number(this.paymentForm.controls.amount?.value),
            payment_type:
              this.paymentForm.controls.gateway?.value?.title.toString(),
          };
          this.gaService.sendAnalytics("add_payment_info", eventData);
        } catch {}
        let vm = this;
        this.loaderService.show();
        try {
          if (isDevMode() && false) {
            bitpay.enableTestMode();
          }
          bitpay.showInvoice(success.transaction_id);
          bitpay.onModalWillEnter(function () {
            vm.gatewayReady = true;
            vm.loaderService.hide();
          });

          bitpay.onModalWillLeave(function () {
            window.location.href = "online-payments";
          });
        } catch {
          vm.loaderService.hide();
          this.snackbarService.showSnack(
            "BitPay is not available in your country!"
          );
        }
      },
      (error) => {
        this.snackbarService.showSnack(error.detail);
      }
    );
  }

  initNGeniusConfig(cardMethodId?: any): void {
    const payData = { ...this.paymentForm.value };
    payData.gateway = payData.gateway.id;
    // payData.amount = payData.amount.replaceAll(',', '');
    payData.redirect_url = environment.gatewayReturnUrl;
    payData.method_id = cardMethodId;
    // this.gatewayReady = false;

    this.paymentService.createOnlinePayment(payData).subscribe(
      (success) => {
        if (cardMethodId) {
          this.closeDialogs();
          this.router.navigate(["/online-payments"]);
        } else {
          try {
            let eventData = {
              currency:
                this.paymentForm.controls?.gateway?.value?.currency?.symbol.toString(),
              value: Number(this.paymentForm.controls.amount?.value),
              payment_type:
                this.paymentForm.controls.gateway?.value?.title.toString(),
            };
            this.gaService.sendAnalytics("add_payment_info", eventData);
          } catch {}
          this.document.location.href = success.info.redirect_url;
        }
      },
      (error) => {
        let txt = error.detail;
        if (error.code == "775") {
          txt = `For this action, KYC registration is required. To register your company, please go to <a href="https://register.ezpin.com" target="_blank">"register.ezpin.com"</a> and enter your email address (${this.userInitInfo.profile.email}). Once your information has been reviewed by ${this.envrionmentConfig.title}, you will be able to use this method of payment. You may use the ${this.envrionmentConfig.title} redeem gift card to top-up your wallet in the meantime.`
        }
        if (error.detail.indexOf("[ErrorDetail(string='") != -1) {
          txt = txt.replace("[ErrorDetail(string='", "");
          txt = txt.replace("', code='invalid')]", "");
          try {
            txt = JSON.parse(txt)["Message"] || error.detail;
          } catch {}
        }
        this.snackbarService.showSnack(txt);
      }
    );
  }

  onNgeniusValidate() {
    const externalParams = this.route.snapshot.parent.queryParams;
    if (externalParams.ref || externalParams.uID || externalParams.orderId) {
      const approvedData = {
        orderID:
          externalParams.ref || externalParams.uID || externalParams.orderId,
      };
      this.paymentService.validateOnlinePayment(approvedData).then(() => {
        this.resolverService.updateInfo();
        this.router.navigate(["/online-payments"]);
      });
    } else return;
  }

  initPaypalConfig(): void {
    this.gatewayReady = false;
    const payData = { ...this.paymentForm.value };
    let clientID = payData.gateway.client_id;
    payData.gateway = payData.gateway.id;
    // payData.amount = payData.amount.replaceAll(',', '');

    this.payPalConfig = {
      clientId: clientID,
      createOrderOnServer: () =>
        fetch(`${environment.baseUrlTwo}/finance/online-payments/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: this.localStorage.accessToken,
          },
          body: JSON.stringify(payData),
        })
          .then((res) => {
            return res.json();
          })
          .then((data) => {
            return data.transaction_id;
          }),
      authorizeOnServer: (approveData) =>
        this.paymentService.validateOnlinePayment(approveData).then(() => {
          this.resolverService.updateInfo();
          this.router.navigate(["/online-payments"]);
        }),
      onCancel: (data, actions) => {
        this.snackbarService.showSnack("Payment Cancelled");
      },
      onError: (err) => {
        this.snackbarService.showSnack(err);
      },
      onClick: (data, actions) => {},
      onInit: () => {
        this.gatewayReady = true;
      },
    };
  }

  redeemHiGift(card) {
    const payData = {
      // currency: card.currency.id,
      amount: card.remaining,
      gateway: this.paymentForm.get("gateway").value.id,
    };

    this.paymentService.createOnlinePayment(payData).subscribe(
      (data) => {
        try {
          let eventData = {
            currency: card.currency.symbol.toString(),
            value: Number(payData.amount),
            payment_type: this.paymentForm
              .get("gateway")
              .value.title.toString(),
          };
          this.gaService.sendAnalytics("add_payment_info", eventData);
        } catch {}
        const obj = {
          transaction_id: data.transaction_id,
          pin: this.hiGiftForm.get("pin").value.split("-").join(""),
        };

        this.paymentService.validateOnlinePayment(obj).then(() => {
          this.closeDialogs();
          this.snackbarService.showSnack(
            "The voucher has been successfully redeemed"
          );
          this.resolverService.updateInfo();
        });
      },
      (error) => {
        this.snackbarService.showSnack(error.detail);
      }
    );
  }

  setGateway(gateway, skip_card = false) {
    // this.showRightSide = false;
    if (gateway?.payment_method_type != 2 && !skip_card) {
      this.getCustomerCardList(gateway);
      return;
    }

    this.gatewayReady = true;
    this.visibleGateway = gateway?.online_gateway;
    this.paymentForm.patchValue({
      gateway,
      image: undefined,
      currency: gateway.currency?.id || 1,
    });
    this.selectedGateway = gateway;

    if (this.selectedGateway.online_gateway == PaymentGateways.HIGIFT) {
      this.paymentForm.patchValue({ amount: "" });
      this.paymentForm.get("amount").disable();
      this.showAmount = false;
      this.initConfig();
    } else {
      this.showAmount = true;
      this.paymentForm.get("amount").enable();
    }

    if (this.selectedGateway.online_gateway == PaymentGateways.CHEQUE) {
      this.paymentForm.get("image").setValidators(Validators.required);
    } else {
      this.paymentForm.get("image").setValidators(undefined);
    }

    let dialogRef = this.dialog.open(this.createPaymentDialog, {
      width: "760px",
      disableClose: false,
      data: gateway,
    });

    dialogRef.afterClosed().subscribe(() => {
      if (this.paymentForm.value?.image) {
        this.selectedImage = undefined;
      }
    });
  }

  getUserPaymentEmails() {
    this.paymentService.getUserPaymentEmails().subscribe((data) => {
      this.paymentEmailList = data.results;

      if (!data.results.length) {
        // this.openDialog(this.createPaymentEmail);
        this.visibleGateway = PaymentGateways.PAYPAL_EMAIL_ERROR;
      } else {
        this.initPaypalConfig();
      }
    });
  }

  setUserPaymentEmail() {
    this.paymentService
      .createUserPaymentEmail(this.paymentEmailForm.value)
      .subscribe(() => {
        this.closeDialogs();
        this.getUserPaymentEmails();
      });
  }

  openDialog(content) {
    this.dialog.open(content, {
      width: "500px",
      disableClose: true,
    });
  }

  closeDialogs() {
    this.dialog.closeAll();
  }

  checkHiGiftPin() {
    let pin = { pin: this.hiGiftForm.get("pin").value.split("-").join("") };
    this.paymentService.checkHiGift(pin).subscribe(
      (data) => {
        this.dialog.open(this.checkHiGift, {
          data: data,
          panelClass: "custom-dialog",
          disableClose: true,
          autoFocus: false,
        });
      },
      (error) => {
        this.snackbarService.showSnack(error.detail);
      }
    );
  }

  pinValueChanges() {
    this.pinSubscribtion$ = this.hiGiftForm
      .get("pin")
      .valueChanges.subscribe((data) => {
        this.addHyphen(data);
      });
  }

  addHyphen(val) {
    let insertValue = val.split("-").join("");
    if (insertValue.length > 0) {
      insertValue = insertValue.match(new RegExp(".{1,4}", "g")).join("-");
    }
    this.hyphenValue = insertValue;
  }

  ngOnDestroy() {
    this.pinSubscribtion$.unsubscribe();
  }

  checkVisibility(gateway) {
    return this.visibleGateway == gateway;
  }

  onFileChanged(event) {
    if (!event.target.files.length) {
      return;
    }
    const reader = new FileReader();

    reader.onload = (e) => {
      this.selectedImage = e.target.result;
    };

    const file = event.target.files[0];
    reader.readAsDataURL(file);
    this.paymentForm.patchValue({
      image: file,
    });
  }

  submitCheque() {
    this.closeDialogs();
    var data = new FormData();
    const form = { ...this.paymentForm.value };
    form.gateway = form.gateway.id;
    // form.amount = form.amount.replaceAll(',', '');

    for (let field in form) {
      if (form[field]) {
        data.append(field, form[field]);
      }
    }
    this.paymentService.createOnlinePayment(data).subscribe(
      (result) => {
        try {
          let eventData = {
            currency: form.gateway.currency.symbol.toString(),
            value: Number(form.amount),
            payment_type: form.gateway.title.toString(),
          };
          this.gaService.sendAnalytics("add_payment_info", eventData);
        } catch {}
        this.paymentService
          .validateOnlinePayment({ transaction_id: result.transaction_id })
          .then(() => {
            this.resolverService.updateInfo();
            this.router.navigate(["/online-payments"]);
          });
      },
      (error) => {
        this.snackbarService.showSnack(error.detail);
      }
    );
  }

  downloadBankTransferInvoice() {
    this.bankTransferInvoice.downloadAsPDF();
    this.dialog.afterAllClosed.subscribe(() => this.bankTransferForm.reset());
  }
}
